import { createFileRoute, notFound } from '@tanstack/react-router';
import { workspaceQuery } from '@/features/workspaces/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management',
)({
  beforeLoad: async ({ context, params }) => {
    const workspace = await context.queryClient.query({
      ...workspaceQuery(params.workspaceId),
      staleTime: 'static',
    });
    if (workspace.type !== 'contract') throw notFound();
  },
});
